// 한국어
export default {
	common: {
		requestFailed: '요청에 실패했습니다',
		needLogin: '로그인이 필요합니다',
		accountLoggedOut: '계정이 로그아웃되었습니다',
		confirm: '확인',
		cancel: '취소',
	},
	nav: {
		home: '홈',
		list: '목록',
		game: '인증됨',
		video: '영화',
		mine: '나',
	},
	route: {
		home: '홈',
		choose: '상대 선택',
		list: '상대 리스트',
		profile: '상세 정보',
		mine: '마이페이지',
		video: '영상',
		game: '게임',
		login: '로그인',
		register: '회원가입',
		serviceOnline: '온라인 서비스',
		servicePage: '온라인 서비스',
		setting: '설정',
		infomation: '기본 정보',
		setname: '실명 변경',
		setsex: '성별 변경',
		setPayPassword: '결제 비밀번호 관리',
		setLoginPassword: '로그인 비밀번호 관리',
		lottery: '상세 페이지',
		notice: '공지',
		playVideo: '영상 재생',
		setbank: '수취 계좌 정보 입력',
		bindCard: '은행 계좌 연결',
		withdraw: '출금',
		personalreport: '개인 리포트',
		withdrawRecord: '출금 내역',
		gameRecord: '태스크 내역',
	},
	page: {
		login: {
			title: '로그인',
			usernamePlaceholder: '사용자명 입력',
			passwordPlaceholder: '비밀번호 입력',
			forgotPassword: '비밀번호를 잊으셨나요?',
			registerPrompt: '아직 계정이 없으신가요? 지금 가입하기',
			loginBtn: '로그인',
			enterUsername: '사용자명을 입력해 주세요!',
			enterPassword: '비밀번호를 입력해 주세요!',
		},
		mine: {
			recharge: '충전',
			withdraw: '출금',
			myWallet: '내 지갑',
			detail: '내역',
			balance: '잔액',
			personalReport: '개인 리포트',
			accountDetail: '계정 내역',
			taskRecord: '태스크 기록',
			profileCenter: '프로필 센터',
			notice: '공지',
			onlineService: '온라인 서비스',
			refreshSuccess: '새로고침 성공',
			exitTaskWarn: '태스크를 완료한 후 나가 주세요',
			rechargeContactService: '충전은 고객센터에 문의해 주세요',
			setBankCardFirst: '먼저 수취 계좌 정보를 설정해 주세요!',
			functionDisabled: '기능이 비활성화되었습니다!',
			guestUsername: '로그인 / 회원가입',
			guestSubtitle: '로그인하고 더 많은 서비스를 즐겨보세요!',
		},
		setting: {
			navTitle: '설정',
			basicInfoSetting: '기본 정보 설정',
			loginPassword: '로그인 비밀번호',
			payPassword: '결제 비밀번호',
			payPasswordSet: '설정됨',
			payPasswordUnset: '미설정',
			logout: '로그아웃',
			payPasswordAlreadySet: '출금 비밀번호가 설정되어 있습니다. 변경하려면 고객센터에 문의해 주세요',
			language: '언어 전환',
		},
		infomation: {
			navTitle: '기본 정보',
			avatar: '아바타',
			selectAvatar: '아바타 선택',
			realName: '실명',
			notSet: '미설정',
			gender: '성별',
			genderUndefined: '미확인',
			male: '남성',
			female: '여성',
			bankBinding: '은행 계좌 연결',
			linked: '연결됨',
			none: '없음',
		},
		setname: {
			navTitle: '실명 변경',
			save: '저장',
			name: '이름',
			namePlaceholder: '실명을 입력해 주세요',
			nameWarn: '계정 안전을 위해 실명은 연결된 은행 계좌의 이름과 일치해야 합니다',
			dontSetAgain: '다시 설정하지 마세요!',
			enterName: '이름을 입력해 주세요!',
		},
		setsex: {
			navTitle: '성별 변경',
			male: '남성',
			female: '여성',
		},
		setPayPassword: {
			navTitle: '결제 비밀번호 설정',
			enterPassword: '결제 비밀번호 입력',
			confirmPassword: '결제 비밀번호 재입력',
			fillComplete: '모두 입력해 주세요',
			passwordMismatch: '비밀번호가 일치하지 않습니다!',
		},
		setLoginPassword: {
			navTitle: '로그인 비밀번호 변경',
			save: '저장',
			oldPassword: '기존 비밀번호',
			oldPasswordPlaceholder: '기존 비밀번호를 입력해 주세요',
			newPassword: '새 비밀번호',
			newPasswordPlaceholder: '새 비밀번호를 입력해 주세요',
			confirmPasswordPlaceholder: '새 비밀번호를 재입력해 주세요',
			fillComplete: '모든 항목을 입력해 주세요!',
			passwordMismatch: '두 비밀번호가 일치하지 않습니다',
		},
		notice: {
			navTitle: '시스템 공지',
			refreshSuccess: '새로고침 성공',
		},
		serviceOnline: {
			navTitle: '온라인 서비스',
			contact: '문의하기',
			serviceHours: '주 7일 24시간 응대',
		},
		servicePage: {
			navTitle: '고객 서비스',
		},
		withdraw: {
			navTitle: '출금 센터',
			history: '출금 내역',
			amount: '출금 금액',
			all: '전체',
			limit: '출금 한도',
			limitPerTransaction: '1. 1회 출금 한도: 최소 {min} , 최대 {max}',
			limitPerDay: '2. 출금 횟수: 하루 최대 {num}회',
			transferTime: '3. 이체 시간: 보통 약 5분, 가장 빠른 경우 2분 이내',
			balanceLabel: '잔액:',
			withdrawNow: '지금 출금',
			enterCorrectAmount: '올바른 금액을 입력해 주세요',
		},
		withdrawRecord: {
			navTitle: '출금 내역',
			noData: '데이터가 없습니다!',
			amount: '금액:',
			info: '정보:',
			submitTime: '신청 시간:',
			auditTime: '심사 시간:',
			refreshSuccess: '새로고침 성공',
		},
		bindCard: {
			navTitle: '수취 계좌 정보 입력',
			label: '수취 계좌 정보를 입력해 주세요',
			accountNumber: '계좌 번호',
			accountPlaceholder: '은행 계좌 번호를 입력해 주세요',
			bank: '은행',
			bankPlaceholder: '은행을 선택해 주세요',
			warn: '사용자 여러분, 자금 안전을 위해 실명 연결과 출금 비밀번호 설정을 해 주세요. 이름이 계좌명과 일치하지 않으면 출금할 수 없습니다.',
			confirmBind: '계좌 연결 확인',
			enterCardNumber: '카드 번호를 입력해 주세요!',
			selectBank: '은행을 선택해 주세요!',
		},
		setbank: {
			navTitle: '카드 정보',
			addCard: '출금용 카드 정보 추가',
			tip: '팁: 대형 상업은행에 연결해 주세요. 변경하려면 온라인 서비스에 문의해 주세요',
			setNameFirst: '은행 계좌 연결 전에 실명을 설정해 주세요!',
			setPayPasswordFirst: '은행 계좌 연결 전에 출금 비밀번호를 설정해 주세요!',
		},
		personalreport: {
			navTitle: '개인 리포트',
			profitTitle: '손익 금액 ',
			profitFormula: '손익 공식: 당첨 금액 - 베팅 금액',
			taskMoney: '베팅 금액',
			rechargeMoney: '충전 금액',
			withdrawMoney: '출금 금액',
			winMoney: '당첨 금액',
		},
		gameRecord: {
			navTitle: '태스크 내역',
			noData: '데이터가 없습니다!',
			betAmount: '베팅 금액:',
			betTime: '베팅 시간:',
			updateTime: '업데이트 시간:',
			refreshSuccess: '새로고침 성공',
			kim: '금',
			moc: '목',
			thuy: '수',
			hoa: '화',
		},
		home: {
			recommendTask: '추천 태스크',
			viewMore: '더 보기',
			popularRanking: '인기 순위',
			hotRecommend: '추천',
			playCount: '재생:',
			loadingData: '데이터를 불러오는 중...',
			refreshSuccess: '새로고침 성공',
		},
		choose: {
			navTitle: '데이트하고 싶으신가요?',
			city: '도시',
			cityDesc: '커뮤니티는 최고의 신뢰할 수 있는 플랫폼으로, 가장 믿을 수 있는 정보를 공유합니다. 고객 여러분께 신뢰할 수 있고 건전하며 프라이버시가 보호되는 공간을 제공할 것을 약속드립니다.',
			processAndPrice: '절차 및 가격',
			processDesc: '이 웹사이트는 동일 도시 내의 외주 서비스, 비즈니스 동행 및 감정 관련 서비스를 제공합니다. 각 사용자의 프라이버시를 보호하기 위해 고객은 접수 직원 또는 플랫폼의 상급 멤버에게 연락해야만 참여할 수 있습니다.',
			resourcesTitle: '어떤 자원이 있나요?',
			resourcesContent: '유명 아티스트, 모델, 승무원, 젊은 모델, 대학생 등 이 플랫폼에서 불가능한 것은 없습니다',
			serviceScopeTitle: '서비스 범위?',
			serviceScopeContent1: '동일 도시 내 무료 데이트, 전국 모든 지역을 커버하며 주요 도시에 진출해 있습니다. 접수 직원에게 연락하여 예약할 수도 있습니다.',
			serviceScopeContent2: '이 웹사이트는 동일 도시 내의 외주 서비스, 비즈니스 동행 및 감정 관련 서비스를 제공합니다. 각 사용자의 프라이버시를 보호하기 위해 고객은 접수 직원 또는 플랫폼의 상급 멤버에게 연락해야만 참여할 수 있습니다.',
		},
		list: {
			refreshSuccess: '새로고침 성공',
		},
		profile: {
			navTitle: '선택',
			bookAppointment: '예약하기',
			contactConsultant: '컨설턴트 또는 접수 직원에게 문의해 주세요',
		},
		video: {
			navTitle: '시네마',
			noMore: '더 이상 없습니다',
			playCount: '재생:',
			refreshSuccess: '새로고침 성공',
		},
		playVideo: {
			playCount: '회 재생',
			hotRecommend: '추천',
			rechargeToWatch: '영상을 시청하려면 먼저 충전해 주세요!',
		},
		game: {
			navTitle: '투표소',
			all: '전체',
			refreshSuccess: '새로고침 성공',
		},
		register: {
			title: '회원가입',
			usernamePlaceholder: '사용자명 입력 (6~12자 영문/숫자)',
			passwordPlaceholder: '비밀번호 입력 (6~12자 영문/숫자)',
			codePlaceholder: '초대 코드 입력',
			agreementText: '"계정 약관" 조항을 읽고 동의합니다',
			registerBtn: '가입',
			enterUsername: '사용자명을 입력해 주세요!',
			enterPassword: '비밀번호를 입력해 주세요!',
			enterCode: '초대 코드를 입력해 주세요!',
			agreeTerms: '아래 조항에 동의해 주세요!',
		},
		lottery: {
			taskHistory: '태스크 내역',
			rules: '게임 규칙',
			playHint: '플레이 힌트',
			playHintDetail: '선택 가능한 형태와 숫자 중에서 골라 베팅합니다',
			prizeGuide: '당첨 가이드',
			prizeGuideDetail: '당첨된 세 숫자의 합이 11~18이면 "큰", 3~10이면 "작은" 입니다;',
			betExample: '베팅 예시',
			betExampleDetail: '베팅 예시: 작은, 결과: 123 → 작은 당첨',
			taskOrder: '태스크 주문',
			availableBalance: '사용 가능 잔액',
			currency: '분수',
			submit: '제출',
			currentChoice: '현재 선택:',
			betAmount: '베팅 금액:',
			enterAmount: '금액 입력',
			selected: '선택됨',
			total: '합계',
			orderDetail: '1 x {money}đ = {money}',
			clearOrder: '주문 지우기',
			confirmSubmit: '제출 확인',
			periodNumber: '회차',
			resultNumber: '당첨 번호',
			notSelected: '미선택',
			invalidAmount: '잘못된 금액입니다!',
			selectNumber: '숫자를 선택해 주세요!',
			enterAmountWarn: '금액을 입력해 주세요!',
			insufficientBalance: '잔액이 부족합니다. 충전하려면 고객센터에 문의해 주세요!',
			refreshSuccess: '새로고침 성공',
			contactAdminForTask: '이 태스크를 받으려면 관리자에게 연락해 주세요!',
			lotteryResultPeriod: '당첨 결과, 회차: {period}',
			"lotterynow": "이번 회차",
			    "lotterying": "투표 진행 중",
			    "lottery_da": "로켓",
			    "lottery_xiao": "하트",
			    "lottery_dan": "요트",
			    "lottery_shuang": "장미",
			    "lottery_piao": "티켓",
			    "lottery_his": "역사",
			    "lottery_log": "기록",
			    "lottery_sec": "투표 선택"
		},
		ordlan: {
			"PopularMembers": "인기 회원",
			    "Rating": "평점",
			    "AppointmentRequest": "예약 요청",
			    "PersonalVideoVerification": "개인 영상 인증",
			    "IdentityVerification": "신분 인증",
			    "ManagerProfile": "관리자 프로필",
			    "ServiceArea": "서비스 지역",
			    "TravelAvailable": "출장 가능",
			    "Yes": "예",
				help:'돕다',
				AgencyBooking:'Agency Booking',
				More:'More',
		}
	},
}
